const HomeFooter = ({ logo, showCopyright = true }) => (
    <div className="d-flex flex-column align-items-center mb-2 mt-auto">
        {logo ? (
            <img src={logo.ConfigValue} alt="OHOINDIA logo" style={{ height: '40px', width: '40px' }} />
        ) : (
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        )}

        <span className="app-brand-text fw-bolder" style={{ fontSize: '18px', color: '#0094c6' }}>OHOINDIA</span>
        {showCopyright && (
            <span style={{ fontSize: '13px' }}>
                All rights reserved. Copy right <i className="bi bi-c-circle"></i> OHOINDIA
            </span>
        )}
        <span className="fw-semibold mt-3" style={{ color: '#0E94C3', fontSize: '13px' }}>
            Powerd by OHOINDIA TECHNOLOGY v1.0
        </span>
        <a href="https://www.ohoindialife.in/privacypolicy" target="_blank" rel="noreferrer" style={{ color: '#0E94C3' }}>
            Privacy Policy
        </a>
    </div>
);

export default HomeFooter;
